export default __webpack_public_path__ + "static/media/logo.1beda0d3.webp";